import { PlanType } from 'api-validations/user-api'
import { generatePath, Navigate } from 'react-router'
import { useAccount, useRecentOrgCodes } from 'shared-ui/active-operation'
import { Loading } from 'shared-ui/components'

import { path } from '../../../routes/paths'

export const RedirectToOrgHome = () => {
  const account = useAccount()
  const recentOrgCodes = useRecentOrgCodes()

  if (account.isPending) {
    return <Loading />
  }

  if (account.isError) {
    // this is already handled by AuthGuard, so we should not reach here
    throw account.error
  }

  const orgCode = recentOrgCodes[0] ?? account.data.defaultOperation.orgCode

  if (account.data.isNewUser) {
    return <Navigate to={generatePath(path.gettingStarted)} replace />
  }

  // Check if the target org is a dealer org and redirect appropriately
  const targetOrg = account.data.orgMemberships.find((m) => m.orgCode === orgCode)
  if (targetOrg?.planType === PlanType.Dealer) {
    return <Navigate to={generatePath(path.dealerOperations, { orgCode })} replace />
  }

  return <Navigate to={generatePath(path.home, { orgCode })} replace />
}
